import appGlobalScript from '/tmp/scratch/ticom-feature-components_VF2ci/src/global/index.ts';
export const globalScripts = appGlobalScript;
